import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DesktopGuard implements CanActivate {
  constructor(
    private deviceDetectorService: DeviceDetectorService
  ) { }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.deviceDetectorService.isDesktop()) {
      return false;
    }
    return true;
  }

}
